import { Inject, Injectable, InjectionToken } from '@angular/core';
import { LoggerService } from '../logger';

export const INTERCOM_APP_ID = new InjectionToken<string>('intercomAppId');

@Injectable({
    providedIn: 'root'
})
export class IntercomService {

    constructor(
        private logger: LoggerService,
        @Inject(INTERCOM_APP_ID) private intercomAppId: string
    ) {

    }
    boot(user: IntercomUser) {
        if (window.Intercom) {

            if (user.id) {

                if (user.isAdmin) {
                    window.Intercom('boot', {
                        app_id: this.intercomAppId,
                        user_id: user.id,
                        name: user.fullname,
                        email: user.email,
                        user_hash: user.userHashForIntercom
                    });
                }
            } else {
                this.logger.warn('Unable to load Intercom, no user in scope');
            }
        } else {
            this.logger.error('Unable to load Intercom, no lib found');
        }

    }
    open_chat(message?: string) {
        if (window.Intercom) {
            window.Intercom('showNewMessage', message);
        }
    }
    update() {
        if (window.Intercom) {
            window.Intercom("update");
        }
    }
}

interface IntercomUser {
    id: string;
    fullname: string;
    email: string;
    userHashForIntercom: string;
    isAdmin: boolean;
}